import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault
} from 'use-query-params'
import { DEFAULT_TABLE_FILTERS } from './activityHistoryConstants'
import { UserActivityHistoryInput } from '../../graphql/private/PrivateSchemaTypes'

export type ActivityHistoryFiltersType = Omit<
  UserActivityHistoryInput,
  'from' | 'to' | 'limit' | 'cpdOnly'
>

const QUERY_FILTER_CONFIG = {
  search: withDefault(StringParam, ''),
  orderColumn: withDefault(StringParam, DEFAULT_TABLE_FILTERS.orderColumn),
  orderDirection: withDefault(
    StringParam,
    DEFAULT_TABLE_FILTERS.orderDirection
  ),
  page: withDefault(NumberParam, DEFAULT_TABLE_FILTERS.page)
}

export const useActivityHistoryFiltersFromQuery = () => {
  return useQueryParams(QUERY_FILTER_CONFIG)
}
